Ext.define('SA.ScrollView', {
    constructor() {
        this.el = SA.Html.create({type: 'div', class: 'sa-scroll-view'});
    },

    getEl() {
        return this.el;
    },

    getSize() {
        return SA.Html.getSize(this.el);
    },

    refreshSize() {
        if (!this.maxSize || !this.content) {
            return;
        }

        var {size} = SA.ConstrainedSize.get({maxSize: this.maxSize, intrinsicSize: SA.Html.getSize(this.content)});

        SA.Html.setSize(this.el, size);
    },

    setContent(content) {
        this.content = SA.Html.setChild(this.el, content);

        this.refreshSize();
    },

    setMaxSize(maxSize) {
        this.maxSize = maxSize;

        this.refreshSize();
    }
});